'use client';

import Image from '@src/components/atoms/safe-image';
import { useRouter } from 'next/navigation';

import One21 from '@public/png/one21-white.png';
import IRichie from '@public/png/i-richie.png';
import Century21 from '@public/png/i-century21-indonesia-horizontal.png';
import BCA from '@public/png/icon-bca-color.png';
import BNI from '@public/png/icon-bni-color.png';
import BRI from '@public/png/icon-bri-color.png';
import BSI from '@public/png/icon-bsi-color.png';
import Mandiri from '@public/png/icon-mandiri-color.png';
import Danamon from '@public/png/icon-danamon-color.png';
import CIMB from '@public/png/icon-cimb-color.png';
import Maybank from '@public/png/icon-maybank-color.png';
import Panin from '@public/png/icon-panin-color.png';

import useWhatsappMessage from '@src/hooks/useWhatsapp';

const phone = '+6285692588739';

const Footer = () => {
  const router = useRouter();
  const { sendMessage } = useWhatsappMessage();

  const handleSendMessage = (type = 'button') => {
    if (type === 'anchor') {
      return sendMessage({
        phone: phone,
        type,
        message: 'Hi Century 21 Indonesia',
      });
    }

    sendMessage({
      phone: phone,
      type,
      message: 'Hi Century 21 Indonesia',
    });
  };

  const handleToHomepage = () => {
    router.push('/');
  };

  return (
    <div className="bg-[#141415]">
      <div
        className="w-full bg-[#141415] mx-auto px-[48px] max-w-[1440px] pt-6
      dd2-2xl:px-[24px] dd2-2xl:max-w-[unset]
      dd2-xl:pb-[100px] dd2-xl:pt-6"
      >
        <div
          className="flex items-end justify-between gap-[24px] 
          dd3-xl:block"
        >
          <div className="py-[40px] w-(calc(100%-172px))">
            <div className="grid grid-cols-[326px_210px_210px_325px] items-start gap-x-[24px] gap-y-[32px]
            dd3-3xl:grid-cols-[270px_172px_172px_270px] 
            dd3-3xl:grid-cols-2 
            dd3-md:grid-cols-1">
              <div className="flex flex-col gap-[12px]">
                <Image
                  src={Century21}
                  alt="CENTURY 21 Indonesia"
                  width={190}
                  height={40}
                  className="cursor-pointer object-contain w-full max-w-[190px] h-[40px] mb-2"
                />
                <div className="flex gap-[12px]">
                  <p className="text-[14px] text-[#686A68] leading-[23.8px] tracking-[-0.17px] font-satoshi">
                    Century 21 Indonesia adalah bagian dari jaringan real estate
                    terbesar di dunia, berkomitmen memberikan layanan properti
                    terbaik dengan standar global dan setuhan lokal.
                  </p>
                </div>
              </div>

              <div className="flex flex-col gap-[12px]">
                <p className="text-[17px] text-[#DEDFDE] leading-[23.8px] tracking-[-0.17px] font-satoshi-bold">
                  Sosial Media
                </p>

                <div className="flex gap-[12px]">
                  <p className="text-[14px]/[19.6px] font-satoshi underline underline-offset-4">
                    <a href={handleSendMessage('anchor')}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12.6366 2.27254C14.9979 2.42668 17.2231 3.43426 18.8964 5.1075C20.5696 6.78073 21.5772 9.00601 21.7313 11.3673C21.8854 13.7284 21.1747 16.065 19.7333 17.9415C18.2918 19.8179 16.2175 21.1067 13.8964 21.5665C11.6879 22.004 9.40075 21.6606 7.4198 20.6055L4.22546 21.672C3.96117 21.7601 3.67728 21.7731 3.40613 21.7091C3.13504 21.6451 2.88727 21.5066 2.69031 21.3096C2.49335 21.1127 2.3549 20.8649 2.29089 20.5938C2.2269 20.3227 2.23986 20.0388 2.328 19.7745L3.39636 16.5821C2.34224 14.6017 2.00007 12.3152 2.43738 10.1075C2.89719 7.78628 4.18581 5.71112 6.06238 4.26961C7.93884 2.8283 10.2755 2.11845 12.6366 2.27254ZM12.5389 3.76961C10.541 3.63921 8.56329 4.23934 6.97546 5.45906C5.38776 6.67871 4.2982 8.43462 3.90906 10.3985C3.51999 12.3626 3.85824 14.4019 4.86121 16.1348C4.96885 16.3209 4.99186 16.5442 4.92371 16.7481L3.75085 20.2481L7.25574 19.0802L7.33386 19.0587C7.51552 19.0191 7.70645 19.0486 7.86902 19.1427C9.60186 20.1455 11.6404 20.4838 13.6044 20.0948C15.5685 19.7057 17.3241 18.6153 18.5438 17.0274C19.7635 15.4396 20.3646 13.4628 20.2343 11.4649C20.1038 9.4669 19.2507 7.58386 17.8348 6.16804C16.4191 4.75247 14.5368 3.90002 12.5389 3.76961Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M12.5879 3.02116C14.7676 3.16345 16.8208 4.09384 18.3653 5.63835C19.9098 7.18286 20.8402 9.23609 20.9825 11.4157C21.1247 13.5954 20.4693 15.7529 19.1387 17.4851C17.8081 19.2171 15.8926 20.4064 13.75 20.8308C11.6075 21.2551 9.38359 20.8858 7.49323 19.7917L3.98835 20.9607C3.8562 21.0047 3.71377 21.0112 3.57819 20.9792C3.44275 20.9472 3.31919 20.8774 3.22077 20.779C3.12235 20.6806 3.05257 20.5571 3.02058 20.4216C2.98858 20.286 2.99506 20.1436 3.03913 20.0114L4.21198 16.5105C3.11791 14.6201 2.74861 12.3961 3.17292 10.2536C3.59733 8.11108 4.78659 6.19553 6.51862 4.86491C8.25083 3.53428 10.4083 2.87887 12.5879 3.02116ZM8.86432 7.80047C8.71474 7.80055 8.47289 7.85669 8.26764 8.07977C8.06226 8.30296 7.4836 8.84187 7.48346 9.93817C7.48346 11.0296 8.27853 12.0853 8.39654 12.2419L8.39752 12.2438C8.50967 12.3927 9.97744 14.6444 12.2237 15.6101C12.7576 15.8396 13.1749 15.9762 13.5 16.0788C14.0362 16.2485 14.5244 16.225 14.9102 16.1677C15.3403 16.1036 16.2353 15.6285 16.4219 15.1081C16.6082 14.5883 16.6084 14.1422 16.5528 14.0485C16.497 13.9558 16.3478 13.8983 16.1241 13.7868C15.9003 13.6753 14.8003 13.1372 14.5938 13.0622C14.3884 12.9878 14.239 12.9504 14.0899 13.1735C13.9408 13.3968 13.5116 13.8992 13.3809 14.0476C13.2503 14.1963 13.1193 14.2148 12.8956 14.1032C12.6717 13.9916 11.9503 13.7559 11.0948 12.9968C10.4291 12.4057 9.97929 11.6761 9.84869 11.4528C9.71829 11.2299 9.83477 11.1094 9.94635 10.9987C10.0468 10.8987 10.1702 10.7381 10.2823 10.6081C10.3945 10.4781 10.4321 10.3845 10.5069 10.236C10.5815 10.0873 10.5442 9.95699 10.4883 9.8454C10.4319 9.73253 9.98476 8.63692 9.79791 8.19109C9.61614 7.75665 9.4311 7.81553 9.294 7.80828C9.16335 7.80186 9.01387 7.80047 8.86432 7.80047Z"
                          fill="#FAFAFA"
                        />
                      </svg>
                    </a>
                  </p>
                  <p className="text-[14px]/[19.6px] font-satoshi underline underline-offset-4">
                    <a href="https://www.instagram.com/century21indonesia?igsh=bms1MzVzZTV3cXNi">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M20.25 8C20.25 5.65279 18.3472 3.75 16 3.75H8C5.65279 3.75 3.75 5.65279 3.75 8V16C3.75 18.3472 5.65279 20.25 8 20.25H16C18.3472 20.25 20.25 18.3472 20.25 16V8ZM21.75 16C21.75 19.1756 19.1756 21.75 16 21.75H8C4.82436 21.75 2.25 19.1756 2.25 16V8C2.25 4.82436 4.82436 2.25 8 2.25H16C19.1756 2.25 21.75 4.82436 21.75 8V16Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M16 3C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16ZM12 7.25C9.37665 7.25 7.25 9.37665 7.25 12C7.25 14.6234 9.37665 16.75 12 16.75C14.6234 16.75 16.75 14.6234 16.75 12C16.75 9.37665 14.6234 7.25 12 7.25ZM12 8.75C13.7949 8.75 15.25 10.2051 15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12C8.75 10.2051 10.2051 8.75 12 8.75ZM17.25 5.5C16.5596 5.5 16 6.05964 16 6.75C16 7.44036 16.5596 8 17.25 8C17.9404 8 18.5 7.44036 18.5 6.75C18.5 6.05964 17.9404 5.5 17.25 5.5Z"
                          fill="#FAFAFA"
                        />
                      </svg>
                    </a>
                  </p>
                  <p className="text-[14px]/[19.6px] font-satoshi underline underline-offset-4">
                    <a href="https://www.facebook.com/century21indonesia">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 3C16.9706 3 21 7.02944 21 12C21 16.8869 17.1049 20.8607 12.25 20.9932V14.25H16C16.4142 14.25 16.75 13.9142 16.75 13.5C16.75 13.0858 16.4142 12.75 16 12.75H12.25V10C12.25 9.30964 12.8096 8.75 13.5 8.75H16C16.4142 8.75 16.75 8.41421 16.75 8C16.75 7.58579 16.4142 7.25 16 7.25H13.5C11.9812 7.25 10.75 8.48122 10.75 10V12.75H8C7.58579 12.75 7.25 13.0858 7.25 13.5C7.25 13.9142 7.58579 14.25 8 14.25H10.75V20.9111C6.37126 20.3025 3 16.5463 3 12C3 7.02944 7.02944 3 12 3Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3012 17.5192 21.6105 12.25 21.7432V20.2432C16.6907 20.111 20.25 16.4727 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.1314 6.78687 19.5529 10.75 20.1553V21.667C5.95579 21.0532 2.25 16.9611 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25Z"
                          fill="#FAFAFA"
                        />
                      </svg>
                    </a>
                  </p>
                  <p className="text-[14px]/[19.6px] font-satoshi underline underline-offset-4">
                    <a href="https://www.youtube.com/@century21indonesia">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M2.24996 13.742V10.367C2.24996 8.52277 2.23274 7.35652 2.70894 6.35334C3.09404 5.5422 3.79959 4.76754 4.57125 4.30842C5.52309 3.74216 6.58284 3.6584 8.24312 3.50275C10.8172 3.26146 13.1431 3.26309 15.7441 3.50764C17.4131 3.66455 18.4779 3.74786 19.4296 4.31428C20.2023 4.77417 20.9054 5.54784 21.291 6.36017C21.5367 6.87806 21.6467 7.41958 21.6992 8.05256C21.7506 8.67295 21.75 9.42985 21.75 10.3787V13.7469C21.75 15.5555 21.7671 16.6998 21.3007 17.6942C20.9249 18.4954 20.2274 19.2727 19.4716 19.7332C18.5365 20.3031 17.507 20.4002 15.8955 20.576C13.2038 20.8696 10.8012 20.8678 8.11031 20.574C6.49524 20.3977 5.46342 20.3011 4.52828 19.7313C3.77212 19.2704 3.07525 18.4939 2.69918 17.6922C2.23281 16.6978 2.24996 15.5525 2.24996 13.742ZM3.74996 13.742C3.74996 15.6975 3.76678 16.4356 4.05758 17.0555C4.30858 17.5905 4.80397 18.1425 5.30855 18.45C5.89597 18.808 6.53938 18.8935 8.2734 19.0828C10.8564 19.3648 13.1493 19.3665 15.7324 19.0848C17.4624 18.8961 18.1038 18.81 18.6914 18.452C19.1955 18.1447 19.6916 17.5919 19.9423 17.0574C20.2332 16.4375 20.25 15.7004 20.25 13.7469V10.3787C20.25 9.40549 20.2492 8.72078 20.2041 8.17658C20.16 7.64496 20.077 7.29881 19.9365 7.00275C19.6785 6.45923 19.1791 5.91103 18.6621 5.60334C18.0653 5.24822 17.3976 5.16948 15.6035 5.0008C13.0949 4.76496 10.8628 4.7644 8.38277 4.99689C6.59848 5.16417 5.935 5.24223 5.33785 5.59748C4.82201 5.90448 4.32183 6.45466 4.06441 6.99689C3.7677 7.62196 3.74996 8.37447 3.74996 10.367V13.742Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M8.31246 4.24995C10.8395 4.01304 13.119 4.01366 15.6738 4.25385C17.4054 4.41666 18.2716 4.49816 19.0459 4.95893C19.6907 5.34269 20.2915 6.0037 20.6132 6.68159C20.9995 7.49555 21 8.45669 21 10.3789V13.747C21 15.6282 20.9997 16.5687 20.6211 17.3759C20.3077 18.0438 19.711 18.7088 19.081 19.0927C18.3197 19.5566 17.4842 19.6478 15.8134 19.83C13.1761 20.1177 10.8284 20.1169 8.19136 19.829C6.51684 19.6463 5.67923 19.5548 4.91793 19.0908C4.28764 18.7065 3.69237 18.0422 3.37886 17.374C3.00022 16.5668 2.99996 15.6252 2.99996 13.7421V10.3671C2.99996 8.44889 3.00031 7.48981 3.38668 6.67573C3.70797 5.99889 4.31114 5.33613 4.95504 4.95307C5.72945 4.49241 6.59046 4.41138 8.31246 4.24995ZM9.74996 14.9999L15.75 11.9999L9.74996 8.99995V14.9999Z"
                          fill="#FAFAFA"
                        />
                      </svg>
                    </a>
                  </p>
                </div>
              </div>

              <div className="flex flex-col gap-[12px]">
                <p className="text-[17px] text-[#DEDFDE] leading-[23.8px] tracking-[-0.17px] font-satoshi-bold">
                  Kontak
                </p>
                <p className="text-[14px] leading-[19.6px] font-satoshi text-[#686A68]">
                  Email:{' '}
                  <a className="text-[#686A68] underline underline-offset-4">
                    support@century21.co.id
                  </a>
                </p>
                <p className="text-[14px] leading-[19.6px] font-satoshi text-[#686A68]">
                  Telepon: <a className="text-[#686A68]">021-2988-2121</a>
                </p>
                <p className="text-[14px] leading-[19.6px] font-satoshi text-[#686A68]">
                  Fax: <a className="text-[#686A68]">021-29688711</a>
                </p>
              </div>

              <div
                className="flex flex-col gap-[12px] max-w-[345px]  
            dd2-xl:mb-6"
              >
                <p className="text-[17px] text-[#DEDFDE] leading-[23.8px] tracking-[-0.17px] font-satoshi-bold">
                  Location
                </p>
                <p className="text-[14px] leading-[19.6px] font-satoshi text-[#686A68]">
                  PT. Sagotra Usaha
                </p>
                <p className="text-[14px] leading-[19.6px] font-satoshi text-[#686A68]">
                  Ciputra World Jakarta 2 - Tokopedia Tower 7th Floor Jl. Prof.
                  Dr. Satrio Kav 11 Karet Semanggi - Setiabudi - Jakarta Selatan
                </p>
              </div>
            </div>

            <div className="mt-[40px] flex items-center gap-[24px] mt-[40px] flex-wrap">
              <Image
                src={BCA}
                alt="BCA"
                width={80}
                height={40}
                className="object-contain"
              />
              <Image
                src={BNI}
                alt="BNI"
                width={80}
                height={40}
                className="object-contain"
              />
              <Image
                src={BRI}
                alt="BRI"
                width={80}
                height={40}
                className="object-contain"
              />
              <Image
                src={BSI}
                alt="BSI"
                width={80}
                height={40}
                className="object-contain"
              />
              <Image
                src={Mandiri}
                alt="Mandiri"
                width={80}
                height={40}
                className="object-contain"
              />
              <Image
                src={Danamon}
                alt="Danamon"
                width={80}
                height={40}
                className="object-contain"
              />
              <Image
                src={CIMB}
                alt="CIMB"
                width={80}
                height={40}
                className="object-contain"
              />
              <Image
                src={Maybank}
                alt="Maybank"
                width={80}
                height={40}
                className="object-contain"
              />
              <Image
                src={Panin}
                alt="Panin"
                width={80}
                height={40}
                className="object-contain"
              />
            </div>
          </div>

          <Image
            src={IRichie}
            alt="Mascot Richie"
            width={209}
            height={225}
            priority
            className="cursor-pointer object-contain 
            dd3-2xl:w-[270px] 
            dd3-xl:w-[349px] 
            dd3-lg:w-[288px] 
            dd3-md:w-full"
          />
        </div>

        <div
          className="px-[48px] flex items-center justify-between border-t-[0.5px] py-[12px] border-solid border-[#686A68] 
         dd2-lg:block dd2-xl:px-0"
        >
          <div
            className="flex items-center cursor-pointer"
            onClick={handleToHomepage}
          >
            <p className="text-[14px] font-satoshi text-[#686A68] mr-1">
              Powered by
            </p>
            <Image
              src={One21}
              alt="One21"
              width={45}
              height={12}
              className="object-contain w-[44.769px] h-[12px]"
            />
          </div>
          <p className="text-[#686A68] text-[14px] font-satoshi dd2-lg:text-center">
            © CENTURY 21 Indonesia. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
